/*
 * @description: 处理U型底柜高低柜场景下的台面
 * @Author: Zhanyu Shen
 * @Date: 2022-05-26 13:26:09
 * @LastEditors: Zhanyu Shen
 * @LastEditTime: 2022-06-02 10:18:25
 */
import MeshManage from '../../meshManage';
import { FRAMEDEPTH, TOPPANELCONFIG, SKIRTINGBOARDCONFIG, HIGHTLOW_SINKCABINET_HEIGHT, } from '../../utils/kitchenConfig';
import { CABINET_HEIGHT_TYPE } from '../../utils/enum';
/**
 * 高低台面分段点在L1上，获取L1的台面信息
 * @param renderUThis
 * @param l1HighSinkCabinetFrame 高低柜分段点所在柜体数据
 * @param lengthXLength 没有高低柜的时候的台面长度
 * @returns L1的台面信息数组
 */
export function getLengthXTopPanel(renderUThis, l1HighSinkCabinetFrame, lengthXLength) {
    var _a, _b;
    const highFrameId = (_b = (_a = l1HighSinkCabinetFrame === null || l1HighSinkCabinetFrame === void 0 ? void 0 : l1HighSinkCabinetFrame.frameInfo) === null || _a === void 0 ? void 0 : _a.componentBasic) === null || _b === void 0 ? void 0 : _b.id;
    const highFrameMesh = renderUThis.scene.getMeshByName(highFrameId);
    const highFrameMeshManage = new MeshManage(highFrameMesh);
    const { position: { x: meshX } } = highFrameMesh;
    const { x } = highFrameMeshManage.getModelSize();
    // 原点到分段点的台面，高台面
    const position1 = {
        x: meshX - TOPPANELCONFIG.HEIGHT / 2,
        y: CABINET_HEIGHT_TYPE.Eighty * 0.01 + SKIRTINGBOARDCONFIG.HEIGHT + TOPPANELCONFIG.HEIGHT / 2,
        z: FRAMEDEPTH.BOTTOM / 2 + TOPPANELCONFIG.DEPTH / 2,
    };
    const size1 = {
        width: Math.abs(meshX) + x / 2 + TOPPANELCONFIG.HEIGHT,
        height: TOPPANELCONFIG.HEIGHT,
        depth: FRAMEDEPTH.BOTTOM + TOPPANELCONFIG.DEPTH,
    };
    // 分段点到L1末尾的台面，低台面
    const position2 = {
        x: (meshX - x / 2 - lengthXLength) / 2,
        y: CABINET_HEIGHT_TYPE.Seventy * 0.01 + SKIRTINGBOARDCONFIG.HEIGHT + TOPPANELCONFIG.HEIGHT / 2,
        z: FRAMEDEPTH.BOTTOM / 2 + TOPPANELCONFIG.DEPTH / 2,
    };
    const size2 = {
        width: lengthXLength - (Math.abs(meshX) + x / 2),
        height: TOPPANELCONFIG.HEIGHT,
        depth: FRAMEDEPTH.BOTTOM + TOPPANELCONFIG.DEPTH,
    };
    // 分段点那分割高低柜台面，垂直分段台面宽为正常台面的厚度（40cm）
    const positionExtra = {
        x: meshX - x / 2 - TOPPANELCONFIG.HEIGHT / 2,
        y: (position1.y + position2.y) / 2,
        z: FRAMEDEPTH.BOTTOM / 2 + TOPPANELCONFIG.DEPTH / 2,
    };
    const sizeExtra = {
        width: TOPPANELCONFIG.HEIGHT,
        height: HIGHTLOW_SINKCABINET_HEIGHT - TOPPANELCONFIG.HEIGHT,
        depth: FRAMEDEPTH.BOTTOM + TOPPANELCONFIG.DEPTH,
    };
    // L1=238, L2=190, L3=238, 高低台面，水槽在L1，灶台在L2, 分段点在L1台面前低后高(U型里面低外面高)
    if (l1HighSinkCabinetFrame.isAfterDirection) {
        // 低台面
        position1.x = (meshX + x / 2) / 2;
        position1.y = CABINET_HEIGHT_TYPE.Seventy * 0.01 + SKIRTINGBOARDCONFIG.HEIGHT + TOPPANELCONFIG.HEIGHT / 2;
        size1.width = Math.abs(meshX) - x / 2;
        // 高台面
        position2.x = (meshX + x / 2 + TOPPANELCONFIG.HEIGHT - lengthXLength) / 2;
        position2.y = CABINET_HEIGHT_TYPE.Eighty * 0.01 + SKIRTINGBOARDCONFIG.HEIGHT + TOPPANELCONFIG.HEIGHT / 2;
        size2.width = lengthXLength - size1.width + TOPPANELCONFIG.HEIGHT;
        // 分段点
        positionExtra.x = meshX + x / 2 + TOPPANELCONFIG.HEIGHT / 2;
        positionExtra.y = (position1.y + position2.y) / 2;
    }
    return [{
            position: position1, size: size1,
        }, {
            position: positionExtra, size: sizeExtra,
        }, {
            position: position2, size: size2,
        }];
}
/**
 * 高低台面分段点在L1上，获取L2的台面信息
 * @param renderUThis
 * @param l2HighSinkCabinetFrame 高低柜分段点所在柜体数据
 * @param lengthZLength 没有高低柜的时候的台面长度
 * @returns L2的台面信息数组
 */
export function getLengthZTopPanel(renderUThis, l2HighSinkCabinetFrame, lengthZLength) {
    var _a, _b;
    const highFrameId = (_b = (_a = l2HighSinkCabinetFrame === null || l2HighSinkCabinetFrame === void 0 ? void 0 : l2HighSinkCabinetFrame.frameInfo) === null || _a === void 0 ? void 0 : _a.componentBasic) === null || _b === void 0 ? void 0 : _b.id;
    const highFrameMesh = renderUThis.scene.getMeshByName(highFrameId);
    const highFrameMeshManage = new MeshManage(highFrameMesh);
    const { position: { z: meshZ } } = highFrameMesh;
    const { z } = highFrameMeshManage.getModelSize();
    // 水槽在L1边，灶台在L2边，L2台面沿z轴正方向，前高后低
    // 原点到分段点的台面，高台面
    const position1 = {
        x: -FRAMEDEPTH.BOTTOM / 2 - TOPPANELCONFIG.DEPTH / 2,
        y: CABINET_HEIGHT_TYPE.Eighty * 0.01 + SKIRTINGBOARDCONFIG.HEIGHT + TOPPANELCONFIG.HEIGHT / 2,
        z: (meshZ + z / 2 + FRAMEDEPTH.BOTTOM + TOPPANELCONFIG.DEPTH + TOPPANELCONFIG.HEIGHT) / 2,
    };
    const size1 = {
        width: FRAMEDEPTH.BOTTOM + TOPPANELCONFIG.DEPTH,
        height: TOPPANELCONFIG.HEIGHT,
        depth: meshZ + z / 2 + TOPPANELCONFIG.HEIGHT - FRAMEDEPTH.BOTTOM - TOPPANELCONFIG.DEPTH,
    };
    // 分段点到L2末尾的台面，低台面
    const position2 = {
        x: -FRAMEDEPTH.BOTTOM / 2 - TOPPANELCONFIG.DEPTH / 2,
        y: CABINET_HEIGHT_TYPE.Seventy * 0.01 + SKIRTINGBOARDCONFIG.HEIGHT + TOPPANELCONFIG.HEIGHT / 2,
        z: (lengthZLength + meshZ + z / 2) / 2,
    };
    const size2 = {
        width: FRAMEDEPTH.BOTTOM + TOPPANELCONFIG.DEPTH,
        height: TOPPANELCONFIG.HEIGHT,
        depth: lengthZLength - (meshZ + z / 2),
    };
    // 分段点那分割高低柜台面
    const positionExtra = {
        x: -FRAMEDEPTH.BOTTOM / 2 - TOPPANELCONFIG.DEPTH / 2,
        y: (position1.y + position2.y) / 2,
        z: meshZ + z / 2 + TOPPANELCONFIG.HEIGHT / 2,
    };
    const sizeExtra = {
        width: FRAMEDEPTH.BOTTOM + TOPPANELCONFIG.HEIGHT,
        height: HIGHTLOW_SINKCABINET_HEIGHT - TOPPANELCONFIG.HEIGHT,
        depth: TOPPANELCONFIG.HEIGHT, // 垂直分段台面宽为正常台面的厚度（40cm）
    };
    // 水槽在L3边，灶台在L2边，L2台面沿z轴正方向，前低后高
    if (l2HighSinkCabinetFrame.isAfterDirection) {
        // 原点到分段点的台面，低台面
        position1.z = (meshZ - z / 2 + FRAMEDEPTH.BOTTOM + TOPPANELCONFIG.DEPTH) / 2;
        position1.y = CABINET_HEIGHT_TYPE.Seventy * 0.01 + SKIRTINGBOARDCONFIG.HEIGHT + TOPPANELCONFIG.HEIGHT / 2;
        size1.depth = meshZ - z / 2 - FRAMEDEPTH.BOTTOM - TOPPANELCONFIG.DEPTH;
        // 分段点到L2末尾的台面，高台面
        position2.z = (lengthZLength + (meshZ - z / 2) - TOPPANELCONFIG.HEIGHT) / 2;
        position2.y = CABINET_HEIGHT_TYPE.Eighty * 0.01 + SKIRTINGBOARDCONFIG.HEIGHT + TOPPANELCONFIG.HEIGHT / 2;
        size2.depth = lengthZLength - meshZ + z / 2 + TOPPANELCONFIG.HEIGHT;
        // 分段点那分割高低柜台面
        positionExtra.z = meshZ - z / 2 - TOPPANELCONFIG.HEIGHT / 2;
    }
    return [{
            position: position1, size: size1,
        }, {
            position: positionExtra, size: sizeExtra,
        }, {
            position: position2, size: size2,
        }];
}
/**
 * 高低台面分段点在L3上，获取L3的台面信息
 * @param renderUThis
 * @param l3HighSinkCabinetFrame 高低柜分段点所在柜体数据
 * @param lengthP2XLength 没有高低柜的时候的台面长度
 * @returns L3的台面信息数组
 */
export function getLengthP2XTopPanel(renderUThis, l3HighSinkCabinetFrame, lengthP2XLength) {
    var _a, _b;
    const highFrameId = (_b = (_a = l3HighSinkCabinetFrame === null || l3HighSinkCabinetFrame === void 0 ? void 0 : l3HighSinkCabinetFrame.frameInfo) === null || _a === void 0 ? void 0 : _a.componentBasic) === null || _b === void 0 ? void 0 : _b.id;
    const highFrameMesh = renderUThis.scene.getMeshByName(highFrameId);
    const highFrameMeshManage = new MeshManage(highFrameMesh);
    const { position: { x: meshX, z: meshZ } } = highFrameMesh;
    const { x, z } = highFrameMeshManage.getModelSize();
    // 原点到分段点的台面，高台面
    const position1 = {
        x: (meshX - x / 2 - FRAMEDEPTH.BOTTOM - TOPPANELCONFIG.DEPTH - TOPPANELCONFIG.HEIGHT) / 2,
        y: CABINET_HEIGHT_TYPE.Eighty * 0.01 + SKIRTINGBOARDCONFIG.HEIGHT + TOPPANELCONFIG.HEIGHT / 2,
        z: z / 2 + meshZ - TOPPANELCONFIG.DEPTH / 2 - FRAMEDEPTH.BOTTOM / 2,
    };
    const size1 = {
        width: Math.abs(meshX) + x / 2 - FRAMEDEPTH.BOTTOM - TOPPANELCONFIG.DEPTH + TOPPANELCONFIG.HEIGHT,
        height: TOPPANELCONFIG.HEIGHT,
        depth: FRAMEDEPTH.BOTTOM + TOPPANELCONFIG.DEPTH,
    };
    // 分段点到L1末尾的台面，低台面
    const position2 = {
        x: (meshX - x / 2 - lengthP2XLength) / 2,
        y: CABINET_HEIGHT_TYPE.Seventy * 0.01 + SKIRTINGBOARDCONFIG.HEIGHT + TOPPANELCONFIG.HEIGHT / 2,
        z: z / 2 + meshZ - TOPPANELCONFIG.DEPTH / 2 - FRAMEDEPTH.BOTTOM / 2,
    };
    const size2 = {
        width: lengthP2XLength - (Math.abs(meshX) + x / 2),
        height: TOPPANELCONFIG.HEIGHT,
        depth: FRAMEDEPTH.BOTTOM + TOPPANELCONFIG.DEPTH,
    };
    // 分段点那分割高低柜台面，垂直分段台面宽为正常台面的厚度（40cm）
    const positionExtra = {
        x: meshX - x / 2 - TOPPANELCONFIG.HEIGHT / 2,
        y: (position1.y + position2.y) / 2,
        z: z / 2 + meshZ - TOPPANELCONFIG.DEPTH / 2 - FRAMEDEPTH.BOTTOM / 2,
    };
    const sizeExtra = {
        width: TOPPANELCONFIG.HEIGHT,
        height: HIGHTLOW_SINKCABINET_HEIGHT - TOPPANELCONFIG.HEIGHT,
        depth: FRAMEDEPTH.BOTTOM + TOPPANELCONFIG.DEPTH,
    };
    // L1=238, L2=236, L3=238, 高低台面，水槽在L3，灶台在L2, 分段点在L3台面前低后高(U型里面低外面高)
    if (l3HighSinkCabinetFrame.isAfterDirection) {
        // 低台面
        position1.x = (meshX + x / 2 - FRAMEDEPTH.BOTTOM - TOPPANELCONFIG.DEPTH) / 2;
        position1.y = CABINET_HEIGHT_TYPE.Seventy * 0.01 + SKIRTINGBOARDCONFIG.HEIGHT + TOPPANELCONFIG.HEIGHT / 2;
        size1.width = Math.abs(meshX) - x / 2 - FRAMEDEPTH.BOTTOM - TOPPANELCONFIG.DEPTH;
        // 高台面
        position2.x = (meshX + x / 2 - lengthP2XLength + TOPPANELCONFIG.HEIGHT) / 2;
        position2.y = CABINET_HEIGHT_TYPE.Eighty * 0.01 + SKIRTINGBOARDCONFIG.HEIGHT + TOPPANELCONFIG.HEIGHT / 2;
        size2.width = lengthP2XLength - Math.abs(meshX) + x / 2 + TOPPANELCONFIG.HEIGHT;
        // 分段点
        positionExtra.x = meshX + x / 2 + TOPPANELCONFIG.HEIGHT / 2;
        positionExtra.y = (position1.y + position2.y) / 2;
    }
    return [{
            position: position1, size: size1,
        }, {
            position: positionExtra, size: sizeExtra,
        }, {
            position: position2, size: size2,
        }];
}
